module.exports = __webpack_public_path__ + "static/media/9DESA4.75447a51.jpg";